import dayjs, { extend } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

export const formatStartDate = (startDate: Date) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault("America/Chicago");
    const start = dayjs(startDate);

    return `${start.format("MMM D, YYYY")}`;
};

export function formatUpdateTime(timestamp: string) {
    if (timestamp === "Live") return "Live";
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault("America/Chicago");
    const date = dayjs(timestamp);
    extend(advancedFormat);
    return date.format("MMM D, h:mma z");
}

/** data sourced from Enterprise Data Platform (EDP) is delayed.
 * EDP runs batch jobs run at midnight CST to calculate metrics using analytic events.
 * The jobs typically take around 9 hours to complete. They only use events loaded at midnight.
 * This function determines the last date analytic events were loaded for the latest EDP calculation.
 * If the metric is null then the calculation for the date range hasn't finished even one calculation, so return undefined
 */
export const formatEDPSourcedUpdatedTime = (timestamp?: string) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault("America/Chicago");
    const today = dayjs();
    const yesterday = dayjs().subtract(1, "day");
    const originalDate = dayjs(timestamp);

    if (originalDate.isSame(today, "day")) {
        return today.startOf("day").add(1, "minute").toISOString(); // 12:01am today
    }
    if (originalDate.isSame(yesterday, "day")) {
        return yesterday.startOf("day").add(1, "minute").toISOString(); // 12:01am today
    }

    return undefined;
};
